/**
 * @deprecated no longer used, replaced by {@see DocumentType}
 */
export enum CustomsDocumentType {
  CustomsDocument = 'CustomsDocument',
  Receipt = 'Receipt',
}
